import {useLayoutEffect,useMemo,useRef,useSyncExternalStore} from 'react';
import {createDraft} from '../../browser-recovery/drafts';
import {createBaselineClient,baselineAccountKey,type BaselineClient} from '../client';
import {emptyBaselineDraft,validBaselineDraft} from '../draft';
import type {BaselineAccount} from '../types';
const clients=new Map<string,BaselineClient>();
if(typeof window!=='undefined'){
 window.addEventListener('storage',()=>clients.forEach(c=>c.refreshSaved()));
 window.addEventListener('beforeunload',e=>{if([...clients.values()].some(c=>c.snapshot().pending)){e.preventDefault();e.returnValue='';}});
}
export function useBaselineClient(base:string,a:BaselineAccount,begin?:()=>()=>void){
 const key=baselineAccountKey(base,a),live=useRef(key);live.current=key;
 if(!clients.has(key))clients.set(key,createBaselineClient(base,a,begin));
 const client=clients.get(key)!;client.activate(()=>live.current===key);
 useLayoutEffect(()=>{live.current=key;client.refreshSaved();return()=>{live.current='';};},[key,client]);
 const state=useSyncExternalStore(client.subscribe,client.snapshot);
 return {client,...state,locked:state.busy||state.blocked||!!state.pending};
}
export function useBaselineDraft(key:string){
 const store=useMemo(()=>createDraft(key,'supplier-custody-setup-v1',emptyBaselineDraft(),validBaselineDraft),[key]),state=useSyncExternalStore(store.subscribe,store.snapshot);
 return {...store,...state,locked:state.stale||state.changedElsewhere||state.unreadable||!!state.error};
}
